module.exports = __webpack_public_path__ + "static/impact.767f1929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards_ceremony/impact.png
// module id = 554
// module chunks = 138584234813021